import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>Skyline Digital Solutions</h3>
            <p>Specialized ERP solutions for manufacturing companies in the Benelux region.</p>
          </div>
          <div className="footer-column">
            <h3>Contact</h3>
            <p>Stationsplein 45, Unit 4.004<br/>3013 AK Rotterdam<br/>The Netherlands</p>
            <p>+31 (0)10 123 4567<br/>info@skylinedigitalsolutions.com</p>
          </div>
          <div className="footer-column">
            <h3>Links</h3>
            <ul className="footer-links">
              <li><a href="#features">Features</a></li>
              <li><a href="#product">WorkflowNL</a></li>
              <li><a href="#testimonials">Clients</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Follow Us</h3>
            <ul className="footer-links">
              <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a></li>
              <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Skyline Digital Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;